import React from 'react';
import { Alert } from '@mui/material';
import { isProspectiveInventoryStatus } from 'modules/equipment';
import { InventoryEquipmentItem } from '../../api';
import { getProspectiveUnitMissingFields } from '../../lib';

interface Props {
  item: InventoryEquipmentItem;
}

// DR-10802 section 5: a deal may be quoted and submitted while its unit is Prospective, but the rep must see
// what is missing. Some lenders reject a submission without a VIN.
export const ProspectiveUnitFlag = ({ item }: Props) => {
  if (!isProspectiveInventoryStatus(item.inventoryStatus)) return null;

  const missingFields = getProspectiveUnitMissingFields(item);

  return (
    <Alert severity="warning" sx={{ width: '100%' }} onClick={e => e.stopPropagation()}>
      Prospective unit
      {missingFields.length ? `: missing ${missingFields.join(' and ')}.` : '.'} Some lenders need these to approve.
      Edit the unit and set its status to Available or Reserved once the real unit is sourced.
    </Alert>
  );
};
